import Footer from "common/src/components/Footer";
import { lazy, Suspense } from "react";
import Navbar from "../common/Navbar";
import IUCApplications from "./IUCApplications";
import HomeImage from "../../assets/HomeImage.png";
import { Button } from "common/src/styles";
import { MagnifyingGlassIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LandingBannerLogo = /*#__PURE__*/lazy(() => import("../../assets/LandingBanner"));
const SectionHero = () => {
  const GRANT_BUILDER = process.env.REACT_APP_GRANT_BUILDER;
  return /*#__PURE__*/_jsx("div", {
    className: "absolute inset-0 flex items-center justify-center backdrop-brightness-75 backdrop-blur-[2px]",
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative text-center xl:text-left flex flex-col items-center xl:flex-row space-y-10 xl:items-center space-x-0 xl:space-x-10",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "w-screen max-w-full space-y-5 xl:max-w-xl",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "text-2xl !leading-tight font-semibold text-white xl:text-5xl mix-blend-luminosity",
          children: "Support \uD83D\uDD4A\uFE0F, Help, and Fund Grants for Iranians"
        }), /*#__PURE__*/_jsx("span", {
          className: "block mx-auto xl:mx-0 max-w-lg text-sm xl:text-lg text-neutral-100 mix-blend-luminosity",
          children: "Send ETH to the grant areas you want to support\u2014the recipients will get the funds directly in their wallets."
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex space-x-4 justify-center xl:justify-start",
          children: [/*#__PURE__*/_jsx(Link, {
            to: "/#applications",
            children: /*#__PURE__*/_jsxs(Button, {
              $variant: "secondary",
              className: "flex items-center",
              children: [/*#__PURE__*/_jsx(MagnifyingGlassIcon, {
                className: "text-current h-6 w-6 mr-1"
              }), /*#__PURE__*/_jsx("span", {
                className: "",
                children: "Explore"
              })]
            })
          }), GRANT_BUILDER && /*#__PURE__*/_jsx("a", {
            href: GRANT_BUILDER,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/_jsxs(Button, {
              className: "flex items-center",
              children: [/*#__PURE__*/_jsx(PencilSquareIcon, {
                className: "text-current h-6 w-6 mr-1"
              }), /*#__PURE__*/_jsx("span", {
                children: "Create"
              })]
            })
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "hidden lg:block",
        children: /*#__PURE__*/_jsx("img", {
          className: "w-full object-cover max-w-[33vw]",
          src: HomeImage,
          alt: "Home Hero"
        })
      })]
    })
  });
};
const LandingPage = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {}), /*#__PURE__*/_jsxs("div", {
      className: " mx-auto pt-8",
      children: [/*#__PURE__*/_jsxs("main", {
        className: "scroll-smooth",
        children: [/*#__PURE__*/_jsx(Suspense, {
          fallback: /*#__PURE__*/_jsx("div", {
            style: {
              width: "100%",
              height: "560px"
            }
          }),
          children: /*#__PURE__*/_jsxs("div", {
            className: "relative mt-[44px] xl:mt-[66px]",
            children: [/*#__PURE__*/_jsx(LandingBannerLogo, {
              className: "w-full h-[280px] md:h-auto object-cover rounded-t"
            }), /*#__PURE__*/_jsx(SectionHero, {})]
          })
        }), /*#__PURE__*/_jsxs("div", {
          id: "applications",
          className: "container max-w-[1560px] px-4 md:px-0 md:mx-auto",
          children: [/*#__PURE__*/_jsx("h1", {
            className: "text-3xl mt-11 border-b-2 pb-4",
            children: "Browse through applications"
          }), /*#__PURE__*/_jsx(IUCApplications, {})]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "my-11",
        children: /*#__PURE__*/_jsx(Footer, {})
      })]
    })]
  });
};
export default LandingPage;